import React from 'react';
import {
  FiFileText,
  FiGithub,
  FiLinkedin,
  FiRss,
} from 'react-icons/fi';
import { RiTwitterXLine } from 'react-icons/ri';

export default function SocialMedia() {
  const socialLinks = [
    {
      icon: FiFileText,
      text: 'Resume',
      href: '/resume.pdf',
      hoverColor: 'hover:text-emerald-400',
    },
        
    // {
    //   icon: RiTwitterXLine,
    //   text: 'Twitter',
    //   href: 'https://twitter.com/alkindivv',
    //   hoverColor: 'hover:text-white',
    // },
    {
      icon: FiGithub,
      text: 'Github',
      href: 'https://github.com/alkindivv',
      hoverColor: 'hover:text-violet-400',
    },
    {
      icon: FiLinkedin,
      text: 'LinkedIn',
      href: 'https://www.linkedin.com/in/alkindivv/',
      hoverColor: 'hover:text-blue-400',
    },
    {
      icon: FiRss,
      text: 'Feed',
      href: '/feed.xml',
      hoverColor: 'hover:text-blue-400',
    },
  ];

  return (
    <div className="flex flex-wrap gap-4">
      {socialLinks.map((link, index) => (
        <a
          key={index}
          href={link.href}
          target="_blank"
          rel="noopener noreferrer"
          className={`group relative flex items-center justify-center  backdrop-blur-sm ${link.hoverColor} transition-all duration-300 hover:scale-110`}
          data-tooltip={link.text}
        >
          <link.icon
            className="size-5 social-icon text-neutral-500"
            style={{
              animationDelay: `${index * 0.2}s`,
            }}
          />
          <span className="absolute -top-8 scale-0 transition-all rounded bg-neutral-900 p-2 text-xs text-neutral-50 group-hover:scale-100">
            {link.text}
          </span>
        </a>
      ))}
    </div>
  );
}
